export default "__VITE_ASSET__BP$1IXxn__"